export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_13.4da07472.jpg";